export default __webpack_public_path__ + "static/media/Turtle.0c9410d4.png";